import { render, staticRenderFns } from "./FullscreenExit.vue?vue&type=template&id=6470258a"
import script from "./FullscreenExit.vue?vue&type=script&lang=js"
export * from "./FullscreenExit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports